// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from '../TEMPLATE'

export const Redbubble = createSinglePathSVG({
  path: 'M16.633 16.324h-3.199a.32.32 0 0 1-.32-.322V7.974a.32.32 0 0 1 .32-.32H16.4c2.226 0 2.693 1.31 2.693 2.408q0 .954-.504 1.511c.816.337 1.256 1.096 1.256 2.194 0 1.601-1.201 2.557-3.212 2.557m-4.644 0H5.345a.32.32 0 0 1-.32-.322V7.974a.32.32 0 0 1 .32-.32h3.103c1.939 0 3.096 1.043 3.096 2.791 0 1.163-.585 2.077-1.527 2.448l2.21 2.897a.322.322 0 0 1-.24.533M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12c6.628 0 12-5.373 12-12S18.63 0 12.001 0',
  viewBox: '0 0 24 24',
  glyph: 'Redbubble',
})
